<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      clearable
      no-filter
      :height="multiple ? (model && model.length > 1 ? 'auto' : 32) : '32'"
      :hide-details="rules ? false : true"
      :return-object="filter && !spCurrency ? false : filter && spCurrency ? true : true"
      item-text="name"
      :rules="rules ? rules : []"
      :required="rules ? true : false"
      item-value="id"
      :label="$t(title)"
      :dense="multiple ? (model && model.length > 1 ? false : true) : true"
      :chips="multiple ? multiple : null"
      :multiple="multiple ? multiple : null"
      :filled="filled ? filled : false"
      :flat="flat ? flat : false"
      :solo="solo ? solo : false"
      :disabled="disabled"
      :readonly="isMobile"
      :outlined="outlined ? outlined : true"
      :menu-props="{
        maxHeight: isMobile ? 0 : 200,
        nudgeWidth: 0,
      }"
      :class="{ 'input-new-style': newStyle }"
      @blur="$emit('blur')"
      @click="openMobileDialog"
      @click:clear="onclear"
      @change="$emit('change')"
      @focus="onFocusInput"
    >
      <template v-slot:append>
        <v-slide-x-reverse-transition mode="out-in">
          <v-icon
            :key="`icon-${appendIcon}`"
            :color="notFind ? 'success' : 'secondary'"
            tabindex="-1"
            @click="appendIcon = !appendIcon"
            v-text="notFind ? 'mdi-check-outline' : 'mdi-chevron-down'"
          />
        </v-slide-x-reverse-transition>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle v-if="!isLoading">{{
              $t("no-data")
            }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else>{{ $t("searching") }}</v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
            <v-icon color="success">
              mdi-check-outline
            </v-icon>
          </v-list-item-action> -->
        </v-list-item>
      </template>
      <template v-if="!multiple" v-slot:selection="{ item }">
        <span v-text="item.name" />
      </template>
      <template v-if="multiple" v-slot:selection="{ item, index }">
        <v-chip
          v-if="index < 2"
          close
          small
          dark
          :color="item.color ? item.color : 'primary'"
          class="my-1"
          @click:close="remove(item)"
        >
          {{ item.name }}
        </v-chip>
        <v-chip v-if="model.length > 2 && index === 1" small>
          <span>(+{{ model.length - 2 }} {{ $t("otherItems") }})</span>
        </v-chip>
      </template>
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="append"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              v-on="on"
              @click="setDefault"
            >
              <v-icon medium> mdi-account-check-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("set-to-default") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="
                $store.state.permissions &&
                $store.state.permissions.includes('customer') &&
                newBtn &&
                (type === 'person' || type === 'getAllPersonOffline')
              "
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="accountDialog = true"
            >
              <v-icon medium> mdi-account-plus-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("new-account") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                $store.state.permissions &&
                $store.state.permissions.includes('Product') &&
                ((newBtn && type === 'product') || (newBtn && type === 'productService'))
              "
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="productDialog = true"
            >
              <v-icon medium> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("product") }}</span>
        </v-tooltip>
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                (newBtn && type === 'product') || (newBtn && type === 'productService')
              "
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="barcodeDialog = true"
            >
              <v-icon medium> mdi-barcode-scan </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("barcode") }}</span>
        </v-tooltip> -->
        <v-tooltip v-if="showSerialIcon" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="$emit('serial-click')"
            >
              <v-icon medium class="serial-barcode-icon"> mdi-barcode </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("serial-management") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="newBtn && type === 'given'"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0 !important"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="givenDialog = true"
            >
              <v-icon medium> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("given") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:append-item>
        <div
          v-if="items && items.length !== 0 && last_page > 1 && last_page > current_page"
          v-observe-visibility="{
            callback: visibilityChanged,
          }"
          class="text-center"
        >
          <v-progress-circular :size="20" :width="2" color="primary" indeterminate />
        </div>
      </template>
      <template v-slot:prepend-item>
        <div
          v-if="newBtn && type === 'detail'"
          style="border-radius: 5px; border: 1px solid #e3e3e3; margin: 5px"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="detailDialog = true"
              >
                <v-icon medium> mdi-playlist-plus </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("newdetail") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="accountDialog = true"
              >
                <v-icon medium> mdi-account-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("new-account") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="productDialog = true"
              >
                <v-icon medium> mdi-package-variant </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("new-product") }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="text-wrap" v-text="item.name" />
          <!--        <v-list-item-subtitle v-text="item.symbol" />-->
        </v-list-item-content>
        <v-list-item-action>
          <v-icon v-if="type == 'person'"> mdi-account </v-icon>
          <v-chip
            v-if="type !== 'detail' && item.label"
            class="mx-0"
            :color="item.color ? item.color : 'primary'"
            label
            x-small
            outlined
          >
            {{ $t(item.label) }}
          </v-chip>
        </v-list-item-action>
      </template>
    </v-autocomplete>
    <v-dialog
      v-if="isMobile"
      v-model="mobileDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      content-class="autocomplete-mobile-dialog"
    >
      <!-- Mobile picker (aligned with invoice entity picker) -->
      <v-card class="autocomplete-simple-mobile">
        <header class="autocomplete-simple-mobile__header" dir="ltr">
          <button
            type="button"
            class="autocomplete-simple-mobile__icon-btn"
            :aria-label="$t('back')"
            @click="mobileDialog = false"
          >
            <v-icon size="26" color="#37474F">mdi-arrow-left</v-icon>
          </button>
          <h2 class="autocomplete-simple-mobile__title">{{ mobileDialogTitle }}</h2>
          <div class="autocomplete-simple-mobile__actions">
            <button
              v-if="append"
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('set-to-default')"
              @click.stop.prevent="setDefault"
            >
              <v-icon size="22" color="#607D8B">mdi-account-check-outline</v-icon>
            </button>
            <button
              v-if="
                $store.state.permissions &&
                $store.state.permissions.includes('customer') &&
                newBtn &&
                (type === 'person' || type === 'getAllPersonOffline')
              "
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('new-account')"
              @click.stop.prevent="accountDialog = true"
            >
              <v-icon size="22" color="#607D8B">mdi-account-plus-outline</v-icon>
            </button>
            <button
              v-if="
                $store.state.permissions &&
                $store.state.permissions.includes('Product') &&
                ((newBtn && type === 'product') ||
                  (newBtn && type === 'productService'))
              "
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('product')"
              @click.stop.prevent="productDialog = true"
            >
              <v-icon size="22" color="#607D8B">mdi-plus</v-icon>
            </button>
            <!-- <button
              v-if="
                (newBtn && type === 'product') ||
                (newBtn && type === 'productService')
              "
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('barcode')"
              @click.stop.prevent="barcodeDialog = true"
            >
              <v-icon size="22" color="#607D8B">mdi-barcode-scan</v-icon>
            </button> -->
            <button
              v-if="showSerialIcon"
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('serial-management')"
              @click.stop.prevent="$emit('serial-click')"
            >
              <v-icon size="22" color="#607D8B" class="serial-barcode-icon">
                mdi-barcode
              </v-icon>
            </button>
            <button
              v-if="newBtn && type === 'given'"
              type="button"
              class="autocomplete-simple-mobile__icon-btn"
              :aria-label="$t('given')"
              @click.stop.prevent="givenDialog = true"
            >
              <v-icon size="22" color="#607D8B">mdi-plus</v-icon>
            </button>
          </div>
        </header>

        <div class="autocomplete-simple-mobile__search" dir="rtl">
          <div class="autocomplete-simple-mobile__search-box">
            <v-icon size="22" color="#78909C">mdi-magnify</v-icon>
            <input
              v-model="mobileSearch"
              type="search"
              class="autocomplete-simple-mobile__search-input"
              :placeholder="$t('search')"
              autocomplete="off"
              @keydown.enter.prevent
            />
            <button
              v-if="mobileSearch"
              type="button"
              class="autocomplete-simple-mobile__search-clear"
              :aria-label="$t('clear')"
              @click="mobileSearch = ''"
            >
              <v-icon size="18" color="#78909C">mdi-close-circle</v-icon>
            </button>
          </div>
        </div>

        <div class="autocomplete-simple-mobile__divider">
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="#78909C"
            height="2"
            class="autocomplete-simple-mobile__loader"
          />
        </div>

        <div class="autocomplete-simple-mobile__body" dir="rtl">
          <v-list class="autocomplete-simple-mobile__list pa-0">
            <v-list-item-group
              v-model="mobileModel"
              color="#607D8B"
              :multiple="multiple ? multiple : null"
              class="autocomplete-simple-mobile__group"
            >
              <v-list-item
                v-for="(item, index) in mobileItems"
                :key="index"
                :value="item"
                class="autocomplete-simple-mobile__item"
              >
                <v-list-item-icon class="autocomplete-simple-mobile__index">
                  <span>{{ +index + 1 }}</span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="type === 'person'"
                    class="text-wrap mt-1"
                  >
                    <span v-if="item.phone">
                      {{ $t("phone") }} : {{ item.phone }}
                    </span>
                    <span v-if="item.mobile" class="d-block mt-1">
                      {{ $t("mobile") }} : {{ item.mobile }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-if="item.email && type === 'person'"
                    class="text-wrap"
                  >
                    {{ $t("email") }} : {{ item.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ma-0">
                  <v-icon
                    v-if="isSimpleMobileSelected(item)"
                    color="#607D8B"
                    size="20"
                  >
                    mdi-check
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="justify-center">
                <div
                  v-if="
                    mobileItems &&
                    mobileItems.length !== 0 &&
                    last_page > 1 &&
                    last_page >= page
                  "
                  v-observe-visibility="{
                    callback: visibilityChanged,
                  }"
                  width="100%"
                  height="40px"
                  class="d-flex my-0 pa-2"
                >
                  <v-progress-circular
                    :size="20"
                    :width="2"
                    color="#78909C"
                    indeterminate
                  />
                </div>
              </v-list-item>
              <v-list-item
                v-if="!isLoading && (!mobileItems || !mobileItems.length)"
                class="justify-center"
              >
                <span class="autocomplete-simple-mobile__empty">
                  {{ $t("no-data") }}
                </span>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="accountDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="accountDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("new-account") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: auto">
            <customer
              v-model="newAccount"
              :return-object="true"
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="givenDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="givenDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("accountStracture") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <accountingCoding
              v-model="newGiven"
              :return-object="true"
              @close="givenDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="detailDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="detailDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("accountStracture") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <detail
              v-model="newDetail"
              :return-object="true"
              @input="newDetail"
              @close="detailDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="productDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <product
              v-if="productDialog"
              v-model="newProduct"
              form-type="product"
              :id-prop="value && value.id ? value.id : null"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="barcodeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="440px"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="barcodeDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div class="ma-2 mt-0">
            <barcode
              @decode="(a, b, c) => onDecode(a, b, c)"
              @loaded="() => onLoaded()"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snackbar"
      :text="snakbarText"
      :active="snackbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
    />
  </div>
</template>

<script>
import barcode from "../barcode/barcode";
import customer from "../../../pages/account/customer";
import Product from "../../../pages/product/product";
import accountingCoding from "../../../pages/accounting/coding";
import Detail from "../../../pages/account/detail";
import General from "../../../../../Mixins/general";
export default {
  name: "Autocomplete",
  components: {
    Snakbar: () => import("../snakbar/snakbar"),
    customer,
    accountingCoding,
    Detail,
    Product,
    barcode,
  },
  mixins: [General],
  props: [
    "value",
    "type",
    "append",
    "customerid",
    "newBtn",
    "newStyle",
    "title",
    "currencyProp",
    "data",
    "multiple",
    "rules",
    "init",
    "setInit",
    "outlined",
    "filled",
    "solo",
    "flat",
    "disabled",
    "parent",
    "getInitItemsOff",
    "offline",
    "url",
    "filter",
    "urlKey",
    "setOffline",
    "typeProp",
    "spCurrency",
    "serialBtn",
    "simpleMobile",
  ],
  data: () => ({
    showLoader: true,
    cancelTokenSource: null,
    mobileDialog: false,
    barcodeText: null,
    newProduct: null,
    newGiven: null,
    mobileModel: null,
    newDetail: null,
    givenDialog: false,
    detailDialog: false,
    barcodeDialog: false,
    productDialog: false,
    accountDialog: false,
    isLastPage: false,
    isLoading: false,
    appendIcon: "chevron-down",
    snackbar: false,
    newAccount: null,
    last_page: 1,
    currency: null,
    snakbarText: null,
    snakbarColor: null,
    text: null,
    items: [],
    id: null,
    idd: null,
    // items: Array.from(Array(10).keys()),
    model: null,
    search: null,
    page: 1,
    timer: null,
    notFind: null,
    tab: null,
    initList: null,
    mobileSearch: null,
    oldSearch: null,
    mobileItems: [],
    setInitial: false,
    searchTimeout: 0,
    current_page: null,
  }),
  computed: {
    showSerialIcon() {
      return !!(
        this.serialBtn &&
        (this.type === "product" || this.type === "productService")
      );
    },
    mobileDialogTitle() {
      if (!this.title) return "";
      const translated = this.$t(this.title);
      if (translated && translated !== this.title) return translated;
      return this.title;
    },
  },
  watch: {
    value(val, old) {
      if (this.value) {
        this.setModel(this.value);
      } else {
        this.clear();
        this.getItems({ query: null, page: 1 });
      }
    },
    newAccount() {
      if (this.newAccount) {
        this.accountDialog = false;
        if (this.type === "detail") {
          this.newAccount.id = this.newAccount.fin_id;
        }
        this.setModel(this.newAccount);
      }
    },
    newGiven() {
      if (this.newGiven) {
        this.givenDialog = false;
        this.setModel(this.newGiven);
      }
    },
    newDetail() {
      if (this.newDetail) {
        this.detailDialog = false;
        this.setModel(this.newDetail);
      }
    },
    newProduct() {
      if (this.newProduct) {
        this.productDialog = false;
        if (this.type === "detail") {
          this.newProduct.id = this.newProduct.fin_id;
        }
        this.setModel(this.newProduct);
      }
    },
    customerid(val, oldval) {
      this.setModel(val);
    },
    mobileSearch() {
      this.page = 1;
      this.setInitial = false;
      this.items = [];
      this.mobileItems = [];
      this.getItems();
    },
    model(val) {
      if (val != null) {
        this.tab = 0;
        if (this.notFind) {
          this.text = this.$t("alert-register-success");
          this.snackbar = true;
        }
        this.$emit("input", this.model);
        // if (this.multiple) {
        //   this.$emit('input', this.model)
        // } else {
        //   this.$emit('input'
        //              , {
        //                showButton: true,
        //                name: val.name,
        //                id: val.id,
        //                type: val.type,
        //                code: val.code,
        //                group_id: val.group_id,
        //                remain: val.remain,
        //              })
        // }

        // if (this.id) {
        //   this.$emit('input', this.id)
        // }
      } else {
        this.tab = null;
        this.$emit("input", null);
      }
    },
    search(val, oldSearch) {
      this.oldSearch = oldSearch;
      this.page = 1;
      this.last_page = 1;
      this.setInitial = false;

      if (this.model && this.model.name === val) {
        return false;
      }

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.items = [];
        if (this.multiple && this.model && this.model.length > 0) {
          this.items = this.model;
        }
        this.getItems();
      }, 400); // debounce 400ms
    },
    currencyProp() {
      this.currency = this.currencyProp;
      this.items = [];
      this.page = 1;
      this.initList = false;
      this.getItems();
    },
    offline(val) {
      if (val) {
        this.isLoading = false;
        this.loading = false;
        this.getItemsOffline();
      }
    },
    setOffline(val) {
      if (val) {
        this.isLoading = false;
        this.loading = false;
        this.storedItemsOffline();
      }
    },
    mobileModel(val) {
      this.$emit("input", val);
      if (!this.multiple) {
        this.mobileDialog = false;
      }
    },
  },
  mounted() {
    this.setInitial = this.setInit;
    if (JSON.parse(localStorage.getItem("token"))) {
      this.currency = this.$store.state.currency.id;
      if (this.currencyProp) {
        this.currency = this.currencyProp;
      }
    }
    if (this.value) {
      this.setModel(this.value);
    } else {
      if (this.offline) {
        this.getItemsOffline();
      }
      if (this.setOffline) {
        this.storedItemsOffline();
      } else {
        if (this.setInit) {
          this.getItems();
        }
        if (!this.getInitItemsOff) {
          // this.getItems({ query: null, page: 1 })
        }
      }
    }
  },
  methods: {
    // Used by invoice shared product editor: open dialogs without a second click
    openProductDialog() {
      this.productDialog = true;
    },
    openBarcodeDialog() {
      this.barcodeDialog = true;
    },
    onFocusInput() {
      if (!this.items || (!this.model && this.items.length === 0)) {
        this.getItems();
      }
      // Mobile: first tap often only focuses; open sheet without waiting for a second click.
      // Desktop unchanged — openMobileDialog is gated by isMobile.
      this.openMobileDialog();
    },
    openMobileDialog() {
      if (this.isMobile) {
        this.mobileDialog = true;
        if (this.page === 1 && this.mobileItems.length === 0) {
          this.getItems();
        }
      }
    },
    isSimpleMobileSelected(item) {
      if (!item || this.mobileModel == null) return false;
      if (Array.isArray(this.mobileModel)) {
        return this.mobileModel.some(
          (selected) => selected && selected.id === item.id
        );
      }
      return this.mobileModel.id === item.id;
    },
    onclear() {
      this.$emit("clear");
      this.getItems();
    },
    onDecode(a, b, c) {
      if (a) {
        this.search = a;
        this.barcodeDialog = false;
      }
    },
    onLoaded() {},
    remove(item) {
      if (!this.filter) {
        var index = this.model.findIndex((x) => x.id === item.id && x.type === item.type);
        if (index >= 0) this.model.splice(index, 1);
      } else if (this.filter && this.spCurrency) {
        var index = this.model.findIndex((x) => x.id === item.id && x.type === item.type);
        if (index >= 0) this.model.splice(index, 1);
      } else {
        const i = this.model.indexOf(item.id);
        if (i >= 0) this.model.splice(i, 1);
      }
    },
    setDefault() {
      var app = this;
      if (app.model) {
        app.isLoading = true;
        app.$axios
          .get(this.$endpoint + "getdetail", {
            params: {
              select: "setDefaultAccount",
              id: app.model,
            },
          })
          .then((res) => {
            app.$emit("snackbarShow", { text: res.data.message, color: "green" });
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }
    },
    setModel(item) {
      // this.items = [item]
      var app = this;
      if (this.multiple) {
        app.items = [...app.items, ...Array.from(item)];
        this.search = null;
      } else {
        this.items.push(item);
      }
      this.model = item;
      this.id = item;
    },
    clear() {
      this.items = [];
      this.model = null;
    },
    visibilityChanged(e) {
      e && this.getItems();
    },
    getItems() {
      this.loading = true;
      if (this.offline) {
        this.getItemsOffline();
        return false;
      }
      if (this.page === 1 && !this.search && this.initList && !this.isMobile) {
        return false;
      }
      this.initList = true;
      var app = this;
      app.isLoading = true;

      const query = (this.isMobile ? this.mobileSearch : this.search) || "";
      const trimmedQuery = query.trim();

      var url = app.$endpoint + "getdetail";
      if (app.url) {
        url = app.$apipoint + "getcurrency";
      }
      if (this.urlKey) {
        app.$axios.defaults.headers.common.abr_key = this.urlKey;
      }

      if (app.cancelTokenSource) {
        app.cancelTokenSource.cancel("Canceled due to new request");
      }
      app.cancelTokenSource = app.$axios.CancelToken.source();

      clearTimeout(app.timer);
      app.timer = setTimeout(function () {
        app.$axios
          .get(url, {
            params: {
              select: app.type,
              search: trimmedQuery,
              page: app.page,
              currency: app.currency,
              data: app.data,
              parent_id: app.parent,
              formType: app.typeProp,
            },
            cancelToken: app.cancelTokenSource.token,
          })
          .then((res) => {
            res = res.data;
            if (res.current_page > res.last_page) {
              return false;
            }
            if (app.search && !app.value && app.page === 1) {
              app.items = [];
            }
            var setDef = false;
            if (app.setOffline) {
              app.insertOffline(res.data);
            }
            if (app.setInitial && app.page === 1) {
              setDef = true;
            }
            app.last_page = res.last_page;
            app.current_page = res.current_page;
            if (res.last_page > app.page) {
              app.page++;
            }
            if (!app.isMobile) {
              if (
                app.search &&
                app.search !== app.oldSearch &&
                app.items &&
                app.items.length > 0 &&
                app.page == 1
              ) {
                app.items = Array.from(res.data);
              } else {
                app.items = [...app.items, ...Array.from(res.data)];
              }
            } else {
              app.mobileItems = [...app.mobileItems, ...Array.from(res.data)];
            }

            if (res.last_page === 1) {
              app.items = res.data;
            }
            if (setDef) {
              if (!app.isMobile) {
                app.model = app.items[0];
              } else {
                app.mobileModel = app.mobileItems[0];
              }
            }
            if (res.data.length > 0) {
              app.notFind = null;
            }
            if (app.last_page == app.page) {
              app.loading = false;
            }
          })
          .catch((err) => {
            if (!app.$axios.isCancel(err)) {
              app.serverErrorHandeler(err);
            }
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      this.loading = false;
      this.initList = false;
    },
    storedItemsOffline() {
      var app = this;
      var url = app.$endpoint + "getdetail";
      if (app.url) {
        url = app.$apipoint + "getcurrency";
      }
      if (this.urlKey) {
        app.$axios.defaults.headers.common.abr_key = this.urlKey;
      }
      clearTimeout(app.timer);
      app.timer = setTimeout(function () {
        app.$axios
          .get(
            url +
              "?select=" +
              app.type +
              "&search=" +
              app.search +
              "&page=" +
              app.page +
              "&currency=" +
              app.currency +
              "&data=" +
              app.data +
              "&parent_id=" +
              app.parent
          )
          .then((res) => {
            res = res.data;
            if (!res.data || res.data === undefined) {
              app.insertOffline(res);
            } else {
              app.insertOffline(res.data);
            }
            app.getItemsOffline();
          })
          .catch((err) => {
            ظ;
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      this.loading = false;
    },
    getItemsOffline() {
      var list = JSON.parse(localStorage.getItem(this.type));
      var app = this;
      if (app.search) {
        list = list.filter(function (list) {
          if (app.type === "getAllPersonOffline") {
            return (
              list.name.includes(app.search) ||
              list.code === app.search ||
              list.phone === app.search ||
              list.mobile === app.search
            );
          } else {
            return list.name.includes(app.search) || list.code === app.search;
          }
        });
      }
      if (list) {
        this.items = list;
      } else {
        this.items = [];
      }
      if (this.setInit) {
        app.model = app.items[0];
      }
    },
    insertOffline(items) {
      var type = this.type;
      localStorage.setItem(type, JSON.stringify(items));
    },
  },
};
</script>

<style scoped>
/* add new style with flag */
.input-new-style ::v-deep .v-input__slot {
  background: transparent !important;
  /* background: #e5e5e5 !important; */
  box-shadow: none !important;
}
.input-new-style ::v-deep fieldset {
  border: none !important;
}
.input-new-style ::v-deep .v-input__slot::before,
.input-new-style ::v-deep .v-input__slot::after {
  display: none !important;
}
/**/
.v-progress-circular {
  margin: 4px;
}
::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  overflow: visible;
}
::v-deep .v-input__slot {
  align-items: center;
  overflow: visible;
}
.serial-barcode-icon {
  transform: rotate(90deg);
  transform-origin: center center;
}

.autocomplete-simple-mobile {
  --asm-accent: #607d8b;
  --asm-soft: #eceff2;
  --asm-border: #e0e4e8;
  --asm-bg: #f3f5f7;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  background: var(--asm-bg) !important;
  border-radius: 0 !important;
}

.autocomplete-simple-mobile__header {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 44px 1fr auto;
  align-items: center;
  gap: 4px;
  min-height: 56px;
  padding: 8px 10px;
  background: #fff;
  border-bottom: 1px solid #eceff1;
}

.autocomplete-simple-mobile__title {
  margin: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #263238;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.autocomplete-simple-mobile__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 44px;
}

.autocomplete-simple-mobile__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.autocomplete-simple-mobile__icon-btn:active {
  background: var(--asm-soft);
}

.autocomplete-simple-mobile__search {
  flex: 0 0 auto;
  padding: 12px;
  background: #fff;
}

.autocomplete-simple-mobile__search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  min-height: 48px;
  padding: 0 12px;
  border-radius: 10px;
  background: var(--asm-soft);
  border: 1px solid var(--asm-border);
  box-sizing: border-box;
}

.autocomplete-simple-mobile__search-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 15px;
  font-weight: 500;
  color: #263238;
  text-align: right;
  line-height: 1.4;
}

.autocomplete-simple-mobile__search-input::placeholder {
  color: #90a4ae;
  font-weight: 400;
}

.autocomplete-simple-mobile__search-input::-webkit-search-cancel-button {
  display: none;
}

.autocomplete-simple-mobile__search-clear {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.autocomplete-simple-mobile__divider {
  flex: 0 0 auto;
  position: relative;
  height: 1px;
  background: #eceff1;
}

.autocomplete-simple-mobile__loader {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  margin: 0 !important;
}

.autocomplete-simple-mobile__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 12px 20px;
}

.autocomplete-simple-mobile__list {
  background: transparent !important;
}

.autocomplete-simple-mobile__group {
  background: transparent;
}

.autocomplete-simple-mobile__item {
  min-height: 52px !important;
  margin: 0 0 8px !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  background: #fff !important;
  border: 1px solid #e8eef3 !important;
  box-shadow: none !important;
  align-items: center !important;
}

.autocomplete-simple-mobile__item ::v-deep .v-list-item__icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
}

.autocomplete-simple-mobile__item ::v-deep .v-list-item__content {
  flex: 1 1 auto !important;
  padding: 0 !important;
  align-self: center !important;
}

.autocomplete-simple-mobile__item ::v-deep .v-list-item__action {
  margin: 0 !important;
  align-self: center !important;
  flex: 0 0 auto !important;
}

.autocomplete-simple-mobile__index {
  margin: 0 0 0 10px !important;
  min-width: 28px !important;
  height: 24px !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: center !important;
}

.autocomplete-simple-mobile__index span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 6px;
  background: #e8ecef;
  color: #607d8b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.autocomplete-simple-mobile__item ::v-deep .v-list-item__title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #263238 !important;
  text-align: right;
  line-height: 24px !important;
  min-height: 24px !important;
}

.autocomplete-simple-mobile__item ::v-deep .v-list-item__subtitle {
  font-size: 12px !important;
  color: #78909c !important;
  text-align: right;
}

.autocomplete-simple-mobile__item.v-list-item--active {
  border-color: #c5ced6 !important;
  background: var(--asm-soft) !important;
}

.autocomplete-simple-mobile__item.v-list-item--active
  .autocomplete-simple-mobile__index
  span {
  background: #d5dce2;
  color: var(--asm-accent);
}

.autocomplete-simple-mobile__empty {
  font-size: 13px;
  color: #90a4ae;
  padding: 24px 0;
}
</style>
